export default __webpack_public_path__ + "static/media/Cathy_Inman.b5690400.png";